import React, { useState } from "react";

export default function BankDetailsStep({ setCurrentStep, selectedOffer }) {
  const [formData, setFormData] = useState({
    ifsc: "",
    accountNumber: "",
    accountName: ""
  });
  
  const [bankDetails, setBankDetails] = useState(null);
  const [toggleSelection, setToggleSelection] = useState("yes"); 

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleIfscChange = (e) => {
    const val = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "");
    
    if (val.length <= 11) {
      setFormData({ ...formData, ifsc: val });
      
      if (val.length === 11) {
        setBankDetails({
          bank: "HDFC BANK",
          branch: "MUMBAI - ANDHERI EAST"
        });
      } else {
        setBankDetails(null); 
      }
    }
  };

  const handleSubmit = () => {
    console.log("Saving Bank Details:", { ...formData, toggleSelection, bankDetails });
    setCurrentStep(11); 
  };

  const lenderName = selectedOffer?.lender_name || "CredFin";

  return (
    // 👇 Bumped pb-[100px] to pb-[130px] to give the whole page more breathing room
    <div className="w-full max-w-[400px] mx-auto bg-white min-h-[100dvh] font-atkinson flex flex-col relative pb-[130px]">
      
      {/* Header & Progress Bar */}
      <div className="px-5 pt-6 pb-4 border-b border-transparent">
        <div className="flex justify-center mb-4">
          <div className="text-center leading-none">
            <h1 className="text-[#205A6D] font-bold text-[22px] tracking-tight">
              {lenderName}
            </h1>
            <p className="text-[#7ea4b1] text-[9px] font-semibold tracking-widest mt-1 uppercase">Loans made Easy</p>
          </div>
        </div>
        
        <div className="flex items-center justify-between">
          <button onClick={() => setCurrentStep(9)} className="w-6 h-6 flex items-center justify-start text-gray-700">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          </button>
          
          <div className="flex-1 mx-4 h-[4px] bg-[#e6f4ed] rounded-full overflow-hidden">
            <div className="h-full bg-[#12f280] w-[45%] rounded-full"></div>
          </div>
          
          <span className="text-[12px] text-gray-500 font-medium">45%</span>
        </div>
      </div>

      {/* Main Content */}
      {/* 👇 Added pb-10 here so the inner content pushes past the sticky button */}
      <div className="px-5 pt-2 flex-1 pb-10">
        <h2 className="text-[22px] font-bold text-[#1b1b1b]">Salary bank account</h2>
        <p className="text-[13px] text-[#8b8b8b] mt-2 mb-6 leading-relaxed pr-6">
          Where should we disburse your loan and debit your EMIs?
        </p>

        <div className="flex flex-col gap-4">
          
          {/* IFSC Code */}
          <div>
            <div className="border border-[#e6e6e6] rounded-[12px] px-4 py-2.5 bg-white focus-within:border-black transition-colors">
              <label className="text-[11px] text-[#6b6b6b] block mb-0.5">IFSC code</label>
              <input 
                type="text" 
                name="ifsc"
                value={formData.ifsc}
                onChange={handleIfscChange}
                placeholder="H D F C 0 0 0 0 1 2 3" 
                className="w-full outline-none text-[15px] tracking-widest text-[#1b1b1b] bg-transparent placeholder-[#cccccc] uppercase"
              />
            </div>
            <p className="text-[9px] text-[#b3b3b3] mt-1.5 ml-2 font-medium">Bank auto-detected from IFSC.</p>
          </div>

          {/* Conditional Green Bank Info */}
          {bankDetails && (
            <div className="bg-[#EBFBF4] border border-[#D1EFE2] rounded-[14px] p-4 animate-in fade-in slide-in-from-top-2 duration-300">
              <div className="flex flex-col gap-1.5 text-[12px]">
                <div className="flex justify-between items-center">
                  <span className="text-[#6b6b6b]">Bank</span>
                  <span className="font-bold text-[#1b1b1b] text-right">{bankDetails.bank}</span>
                </div>
                <div className="flex justify-between items-start">
                  <span className="text-[#6b6b6b]">Branch</span>
                  <span className="font-bold text-[#1b1b1b] text-right max-w-[180px] leading-tight">
                    {bankDetails.branch}
                  </span>
                </div>
              </div>
            </div>
          )}

          {/* Account Number */}
          <div className="border border-[#e6e6e6] rounded-[12px] px-4 py-2.5 bg-white focus-within:border-black transition-colors">
            <label className="text-[11px] text-[#6b6b6b] block mb-0.5">Account number</label>
            <input 
              type="text" 
              name="accountNumber"
              value={formData.accountNumber}
              onChange={handleChange}
              inputMode="numeric"
              placeholder="1234567890987" 
              className="w-full outline-none text-[15px] text-[#1b1b1b] bg-transparent placeholder-[#cccccc]"
            />
          </div>

          {/* Account Holder Name */}
          <div className="border border-[#e6e6e6] rounded-[12px] px-4 py-2.5 bg-white focus-within:border-black transition-colors">
            <label className="text-[11px] text-[#6b6b6b] block mb-0.5">Account holder name</label>
            <input 
              type="text" 
              name="accountName"
              value={formData.accountName}
              onChange={handleChange}
              placeholder="As per bank records" 
              className="w-full outline-none text-[15px] text-[#1b1b1b] bg-transparent placeholder-[#cccccc]"
            />
          </div>

          {/* Toggle Section */}
          <div className="mt-2">
            <label className="text-[12px] text-[#6b6b6b] block mb-3 font-medium">
              Is this your salary account?
            </label>
            <div className="flex gap-3">
              <button
                type="button"
                onClick={() => setToggleSelection("yes")}
                className={`flex-1 py-3.5 rounded-full font-bold text-[14px] transition-all duration-200 border ${
                  toggleSelection === "yes" 
                    ? "bg-black text-white border-black" 
                    : "bg-white text-[#1b1b1b] border-[#e6e6e6]"
                }`}
              >
                Yes
              </button>
              
              <button
                type="button"
                onClick={() => setToggleSelection("no")}
                className={`flex-1 py-3.5 rounded-full font-bold text-[14px] transition-all duration-200 border ${
                  toggleSelection === "no" 
                    ? "bg-black text-white border-black" 
                    : "bg-white text-[#1b1b1b] border-[#e6e6e6]"
                }`}
              >
                No
              </button>
            </div>
            
            {toggleSelection === "no" && (
              <p className="text-[#F26E22] text-[10px] mt-2.5 font-medium animate-in fade-in">
                Please provide the account where your salary is credited.
              </p>
            )}
          </div>

        </div>
      </div>

      {/* Sticky Bottom Button */}
      <div className="fixed bottom-0 left-0 right-0 z-50 mx-auto w-full max-w-[400px] bg-white px-5 py-4 border-t border-transparent">
        <button 
          onClick={handleSubmit} 
          disabled={formData.ifsc.length < 11 || !formData.accountNumber || !formData.accountName || toggleSelection === "no"}
          className="w-full font-bold text-[16px] rounded-[14px] py-[18px] transition-colors disabled:bg-[#b5b5b5] disabled:text-white disabled:cursor-not-allowed bg-black text-white active:scale-[0.98]"
        >
          Confirm Bank Account
        </button>
      </div>
    </div>
  );
}